const common = [
    require("../../images/slide1.png"),
];
export const preload = () => {
    common.map(img => {
        const image = new Image();
        image.onload = () => {
            console.log(`${img}加载成功~`);
        };
        image.onerror = () => {
            console.log(`${img}加载失败~`);
        };
        image.src = img;
    })
};


// WEBPACK FOOTER //
// ./js/lib/preload.js